import React from 'react';
import { Tag } from 'lucide-react';
import type { CouleurEtiquette } from '../../lib/reservationsApi';

/** Étiquette de réservation : texte + pastille (jamais la couleur seule). */
const TONS: Record<CouleurEtiquette, string> = {
    neutre: 'bg-surface-soft text-content-muted border border-border',
    info: 'bg-state-info-soft text-state-info',
    ok: 'bg-state-ok-soft text-state-ok',
    warn: 'bg-state-warn-soft text-state-warn',
    danger: 'bg-state-danger-soft text-state-danger',
};
export const COULEURS_ETIQUETTE: { v: CouleurEtiquette; label: string }[] = [
    { v: 'neutre', label: 'Neutre' }, { v: 'info', label: 'Bleu' }, { v: 'ok', label: 'Vert' }, { v: 'warn', label: 'Orange' }, { v: 'danger', label: 'Rouge' },
];
export const EtiquettePastille: React.FC<{ nom: string; couleur: CouleurEtiquette }> = ({ nom, couleur }) => (
    <span className={`inline-flex items-center gap-1 h-[22px] px-2 rounded-full text-[11px] font-semibold whitespace-nowrap ${TONS[couleur] || TONS.neutre}`}><Tag size={11} className="shrink-0" />{nom}</span>
);

/**
 * Sonnerie discrète de « table à libérer » : deux notes courtes et douces (WebAudio, aucun fichier). Désactivée par défaut,
 * réglée par appareil (localStorage) ; l'alerte à l'écran reste la base. Aucune notification hors de l'écran.
 */
const CLE_SONNERIE = 'resa.sonnerie';
export const sonnerieActive = (): boolean => { try { return localStorage.getItem(CLE_SONNERIE) === '1'; } catch (e) { return false; } };
export const reglerSonnerie = (actif: boolean) => { try { localStorage.setItem(CLE_SONNERIE, actif ? '1' : '0'); } catch (e) { /* stockage indisponible : la sonnerie reste coupée */ } };
export const jouerSonnerie = () => {
    try {
        const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
        if (!Ctx) return;
        const ctx = new Ctx();
        const note = (freq: number, debut: number) => {
            const o = ctx.createOscillator(); const g = ctx.createGain();
            o.type = 'sine'; o.frequency.value = freq;
            g.gain.setValueAtTime(0, ctx.currentTime + debut);
            g.gain.linearRampToValueAtTime(0.06, ctx.currentTime + debut + 0.03);
            g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + debut + 0.45);
            o.connect(g); g.connect(ctx.destination); o.start(ctx.currentTime + debut); o.stop(ctx.currentTime + debut + 0.5);
        };
        note(660, 0); note(880, 0.22);
        window.setTimeout(() => void ctx.close(), 1200);
    } catch (e) { /* le navigateur refuse le son : l'alerte à l'écran suffit */ }
};
